<template>
    <f7-sheet
        class="push-message-sheet"
        top
        :backdrop="false"
        swipe-to-close
        close-by-backdrop-click
        close-by-outside-click
        @sheet:closed="closeModal()">
        <div @click="clickPushMessage">
            <div class="push-message-sheet__wrap">
                <div class="push-message-sheet__icon"></div>
                <div class="push-message-sheet__full-width">
                    <div class="push-message-sheet__inline">
                        <div class="push-message-sheet__title">{{ sheet.title }}</div>
                        <div class="push-message-sheet__time">сейчас</div>
                    </div>
                    <div class="push-message-sheet__text">{{ sheet.text }}</div>
                    <!-- <div v-if="sheet.data.link" class="push-message-sheet__buttons">
                        <button class="custom-button" @click.stop="$f7.sheet.close()">
                            Закрыть
                        </button>
                        <button class="custom-button push-message-sheet__button-submit">
                            Перейти
                        </button>
                    </div> -->
                </div>
            </div>
        </div>
    </f7-sheet>
</template>

<script>
    import { pushAction } from '@/js/utils/service-helpers.js';
    export default {
        name: 'PushMessageSheet',
        data: () => ({
            shown: false,
            sheet: {
                router: {},
                title: '',
                text: '',
                type: '',
                data: {},
            },
        }),
        mounted() {
            this.$root.$on(
                'pushMessageSheetShow',
                async ({ router, title, text, type, data }) => {
                    this.sheet = {
                        ...this.sheet,
                        ...{ router, title, text, type, data },
                    };
                    await new Promise(resolve => setTimeout(resolve, 200));
                    this.$f7.sheet.open('.push-message-sheet');
                    await new Promise(resolve => setTimeout(resolve, 10000));
                    this.$f7.sheet.close();
                }
            );
            this.$root.$on('pushMessageSheetHide', () => {
                this.$f7.sheet.close();
            });
        },
        methods: {
            clickPushMessage() {
                pushAction({ type: this.sheet.type, data: this.sheet.data });
                this.$f7.sheet.close();
            },
            closeModal() {
                window.dispatchEvent(new Event('resize'));
            }
        },
    };
</script>

<style lang="scss">
.push-message-sheet {
    width: calc(100% - 16px);
    margin: 0 8px;
    margin-top: calc(constant(safe-area-inset-top) + 12px);
    margin-top: calc(env(safe-area-inset-top) + 12px);
    height: auto;
    background: #FFFFFF80;
    backdrop-filter: blur(58px);
    border-radius: 16px;
    box-shadow: 4px 4px 4px 0px #0000001A;

    .sheet-modal-inner {
        background: none;
        padding: 10px 20px 10px 12px !important;
    }

    &__wrap {
        display: flex;
    }

    &__inline {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    &__full-width {
        flex: 1 0 calc(100% - 48px);
    }
    &__icon {
        min-width: 36px;
        height: 36px;
        margin-top: 2px;
        margin-right: 12px;
        background: url('../../static/push-icon.svg') center center no-repeat;
    }
    &__title {
        font-weight: 500;
        font-size: 16px;
        line-height: 100%;
        color: #3F3F3F;
    }
    &__time {
        font-weight: 500;
        font-size: 12px;
        line-height: 22.83px;
        color: #3F3F3F;
        opacity: .5;
    }
    &__text {
        width: 100%;
        margin-top: 2px;
        font-weight: 400;
        font-size: 14px;
        line-height: 100%;
        color: #3F3F3F;
    }
    &__buttons {
        padding-top: 6px;
        display: flex;
        justify-content: space-between;
        > button {
            width: 48%;
            height: 32px;
        }
    }
    &__button-submit {
        background: #1f3a60;
        color: #ffffff;
    }
}
</style>
